export enum CustomDimensionType {
    requestId = 1,
    requestSuggestionId = 2,
}
